import { render, staticRenderFns } from "./language.vue?vue&type=template&id=51362e77&"
import script from "./language.vue?vue&type=script&lang=js&"
export * from "./language.vue?vue&type=script&lang=js&"
import style0 from "./language.vue?vue&type=style&index=0&id=51362e77&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports